import { useCallback } from 'react'

import { useFocusNodeById, useSetFocus } from '@please/lrud'

import { popupStatus } from '@/constants/popup'
import { useUserInteraction } from '@/hooks/useUserInteraction'
import useStore from '@/store/useStore'

type Props = {
  isVideoError: boolean
  defaultFocusChild: number
  setDefaultFocusChild: (value: number) => void
  slidesLength?: number
  stageDataTimer?: number
  focusIdPrefix?: string
  isEnabled: boolean
}

export const useStageAutoslide = ({
  // isVideoError,
  defaultFocusChild,
  setDefaultFocusChild,
  slidesLength,
  stageDataTimer,
  focusIdPrefix = '',
  isEnabled,
}: Props) => {
  const stageContainerFocusId = `${focusIdPrefix}_StageContainer`
  const focusNode = useFocusNodeById(stageContainerFocusId)
  const setFocus = useSetFocus()

  const { isFullscreen } = useStore((state) => state.player)
  const { isDisabledStageAutoslide } = useStore(
    (state) => state.common.appSettings,
  )
  const currentEvent = useStore((state) => state.common.currentEvent)
  const listPopup = useStore((state) => state.common.listPopup)
  const mediaVideo = useStore((state) => state.common.mediaVideo)
  const youTubeVideo = useStore((state) => state.common.youTubeVideo)
  const { pagePopupStatus } = useStore((state) => state.popup)

  const isPagePopupOpen = pagePopupStatus !== popupStatus.CLOSED

  const hasPopup =
    isFullscreen ||
    listPopup ||
    currentEvent ||
    isPagePopupOpen ||
    mediaVideo ||
    youTubeVideo

  const noInteractionHandler = useCallback(() => {
    const nextChildIndex =
      defaultFocusChild === Number(slidesLength) - 1 ? 0 : defaultFocusChild + 1
    setDefaultFocusChild(nextChildIndex)
    focusNode?.isFocused &&
      setFocus(`${focusIdPrefix}_HomePageStageTile_${nextChildIndex}`)
  }, [defaultFocusChild, focusNode?.isFocused, setDefaultFocusChild])

  const noInteractionIdleTime = stageDataTimer && stageDataTimer * 1000

  // const isChannelVideoError = activeStageSlideType === 'Channel' && isVideoError

  const detectUserInteraction =
    !isDisabledStageAutoslide &&
    // isChannelVideoError &&
    !hasPopup &&
    !!stageDataTimer &&
    isEnabled

  useUserInteraction(
    noInteractionHandler,
    detectUserInteraction,
    noInteractionIdleTime,
  )
}
